export class ConvertResourceSnapshotsResponse {
    'snapshotIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotIds",
            "baseName": "snapshotIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConvertResourceSnapshotsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
